import React from 'react';
import ServicesSection from '../ServicesSection';

const ServicesPage = () => {
  return (
    <div className="py-10">
      <ServicesSection />
    </div>
  );
};

export default ServicesPage;